var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo192(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 340,
    viewBox: "0 0 340 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 170,
    r: 170,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320 170C320 252.843 252.843 320 170 320C87.1573 320 20 252.843 20 170C20 87.1573 87.1573 20 170 20C252.843 20 320 87.1573 320 170ZM49.7386 170C49.7386 236.419 103.581 290.261 170 290.261C236.419 290.261 290.261 236.419 290.261 170C290.261 103.581 236.419 49.7386 170 49.7386C103.581 49.7386 49.7386 103.581 49.7386 170Z",
    fill: "url(#paint0_linear_25_125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.4 168.6C138.133 169.667 137.867 171.133 137.6 173L59 164.6H139L138.4 168.6ZM136.2 183.8C135.8 186.867 135.6 189.667 135.6 192.2L56.8 183.8H136.2ZM143.8 145.4L141.4 153.6L63.8 145.4H143.8ZM135.8 203C136.333 206.733 136.8 209.533 137.2 211.4L59.4 203H135.8ZM152 126.2C150.133 129.667 148.8 132.333 148 134.2L73.2 126.2H152ZM141.8 222.4C143.533 225.467 145.533 227.933 147.8 229.8L78.6 222.4H141.8ZM171 107C167.133 109.4 164.133 111.6 162 113.6L100.8 107H171ZM188.6 235C171.8 235 159.733 231.733 152.4 225.2C145.2 218.667 141.6 208.6 141.6 195C141.6 189.267 142.533 180.8 144.4 169.6C148.4 146.667 155.267 130 165 119.6C174.867 109.2 190.4 104 211.6 104C216.533 104 222.133 104.533 228.4 105.6C234.8 106.533 239.467 107.733 242.4 109.2L231.2 139.8C223.333 137.933 215.933 137 209 137C202.2 137 197.333 137.667 194.4 139C191.467 140.333 189.667 143 189 147L179.8 199.4C184.6 200.467 189.533 201 194.6 201C205.4 201 215.267 199.4 224.2 196.2L221 229.8C212.467 233.267 201.667 235 188.6 235Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_125",
    x1: 268,
    y1: 64.5,
    x2: 79.5,
    y2: 266.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001AFF",
    stopOpacity: 0.72
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo192);
export default __webpack_public_path__ + "static/media/logo192.d91d131bcd3983005bab9812888a46a6.svg";
export { ForwardRef as ReactComponent };